import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/projectConfig',
        name: 'projectConfig',
        meta: { sideMenuLabel: "Configurazione progetto" },
        component: () => import("./views/projectConfigDetail.vue")
    }
];

export default routes;